import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "supplies_box"
};
var _hoisted_2 = {
  class: "search_header",
  style: {
    "width": "400px",
    "margin-bottom": "10px"
  }
};
var _hoisted_3 = {
  class: "search_contain"
};
var _hoisted_4 = {
  class: "search_box",
  id: "search_box"
};
var _hoisted_5 = {
  class: "pagination_"
};
var _hoisted_6 = {
  key: 1,
  class: "supplies_box"
};
var _hoisted_7 = {
  class: "search_header",
  style: {
    "width": "400px",
    "margin-bottom": "10px"
  }
};
var _hoisted_8 = {
  class: "search_contain"
};
var _hoisted_9 = {
  class: "search_box",
  id: "search_box"
};
var _hoisted_10 = {
  class: "pagination_"
};
var _hoisted_11 = {
  key: 2,
  class: "supplies_box"
};
var _hoisted_12 = {
  class: "search_header",
  style: {
    "width": "400px",
    "margin-bottom": "10px"
  }
};
var _hoisted_13 = {
  class: "search_contain"
};
var _hoisted_14 = {
  class: "search_box",
  id: "search_box"
};
var _hoisted_15 = {
  class: "pagination_"
};
var _hoisted_16 = {
  key: 3,
  class: "supplies_box"
};
var _hoisted_17 = {
  class: "search_header",
  style: {
    "width": "700px",
    "margin-bottom": "10px"
  }
};
var _hoisted_18 = {
  class: "search_contain"
};
var _hoisted_19 = {
  class: "search_box",
  id: "search_box"
};
var _hoisted_20 = {
  class: "pagination_"
};
var _hoisted_21 = {
  class: "dialog-footer"
};
import { reactive, ref, watch, watchEffect, onMounted } from "vue";
import { product_wl, get_bd_material, get_standard_custom, quotations_to_contract } from "@/api/apis";
import { prop } from "vue-class-component";

// 添加一个响应式变量用于控制按钮状态

export default {
  __name: 'supplyDailog',
  props: ["current_category", "isShow", "supplies", "title", 'sale_org_name'],
  emits: ["closeDialog", "handleChoose"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var isConfirmDisabled = ref(false);
    var dialogVisible = ref(false);
    var props = __props;
    var emit = __emit;
    var search = () => {
      get_supplies_list();
    };
    /**
     * 选择物料明细
     */

    var suppliesType = ref(1); // 1、标准品 3、定制品
    var current_category = ref("");
    var multipleTableRef1 = ref(null);
    var multipleTableRef2 = ref(null);
    var multipleTableRef3 = ref(null);
    var wl_fy = ref({
      page: 1,
      limit: 10,
      total: 0
    });
    var supplies_list = ref([]); // 物料信息列表
    var key_word = ref("");
    var timerange = ref([]);
    var get_row = row => {
      return row.id;
    };
    var quotation_checked_ids = ref([]);

    /**
     *
     */
    var get_supplies_list = () => {
      if (props.supplies.type == 3) {
        get_bd_material({
          limit: wl_fy.value.limit,
          page: wl_fy.value.page,
          key_word: key_word.value,
          material_group_type: 2,
          status: 1
        }).then(res => {
          if (res.code == 200) {
            wl_fy.value.total = res.data.total;
            supplies_list.value = res.data.list || [];
            toggleCheck(3);
          }
        });
      } else if (props.supplies.type == -1) {
        console.log({
          props
        });
        get_standard_custom({
          key_word: key_word.value,
          limit: wl_fy.value.limit,
          page: wl_fy.value.page,
          user_org_name: props.sale_org_name,
          source: props.title == '报价' ? 4 : props.title == '合同' ? 1 : props.title == '采购' ? 3 : ''
        }).then(res => {
          supplies_list.value = res.data.list || [];
          wl_fy.value.total = res.data.total;
          toggleCheck(-1);
        });
      } else if (props.supplies.type == -2) {
        quotations_to_contract({
          key_word: key_word.value,
          limit: wl_fy.value.limit,
          limit: wl_fy.value.limit,
          page: wl_fy.value.page,
          start: timerange.value[0],
          end: timerange.value[1]
        }).then(res => {
          wl_fy.value.total = res.data.total;
          supplies_list.value = res.data.list || [];
          toggleCheck(-2);
        });
      } else {
        var obj = {
          limit: wl_fy.value.limit,
          page: wl_fy.value.page,
          key_word: key_word.value,
          category: props.supplies.id
        };
        if (props.title == "报价") {
          obj["is_show"] = 0;
        }
        product_wl(obj).then(res => {
          if (res.code == 200) {
            wl_fy.value.total = res.data.total;
            supplies_list.value = res.data.list || [];
            toggleCheck(1);
          }
        });
      }
    };
    var toggleCheck = type => {
      var rows = [];
      supplies_list.value.map((item, index) => {
        if (props.supplies.type == -1) {
          if (quotation_checked_ids.value.findIndex(code => item.code == code) > -1) {
            rows.push(item);
          }
        } else {
          if (quotation_checked_ids.value.findIndex(id => item.id == id) > -1) {
            rows.push(item);
          }
        }
      });
      toggleSelection(rows, type);
    };
    var handle_close = () => {
      dialogVisible.value = false;
      emit("closeDialog");
    };
    var handle_checked = () => {
      if (isConfirmDisabled.value) return; // 如果按钮已被禁用，则直接返回

      // 禁用按钮
      isConfirmDisabled.value = true;

      // 模拟异步操作（例如提交数据）
      dialogVisible.value = false;
      emit("handleChoose", supplies_checked_list.value);

      // 在一定时间后（例如 2 秒）重新启用按钮
      setTimeout(() => {
        isConfirmDisabled.value = false;
      }, 2000); // 2秒后恢复按钮可用状态
    };
    /**
     * 物料信息翻页
     */
    var handleCurrentChange = () => {
      get_supplies_list();
    };
    var supplies_checked_list = ref([]);
    var toggleSelection = (rows, type) => {
      if (rows) {
        rows.forEach(row => {
          if (type == 1) {
            multipleTableRef1.value.toggleRowSelection(row);
          } else if (type == -1) {
            multipleTableRef3.value.toggleRowSelection(row);
          } else {
            multipleTableRef2.value.toggleRowSelection(row);
          }
        });
      } else {
        if (type == 1) {
          multipleTableRef1.value.clearSelection();
        } else if (type == -1) {
          multipleTableRef3.value.clearSelection();
        } else {
          multipleTableRef2.value.clearSelection();
        }
      }
    };
    // 去重
    var unique = tempArr => {
      var result = [];
      var obj = {};
      for (var i = 0; i < tempArr.length; i++) {
        if (!obj[tempArr[i].id]) {
          result.push(tempArr[i]);
          obj[tempArr[i].id] = true;
        }
      }
      return result;
    };
    var handleSelectionChange = data => {
      supplies_checked_list.value = data;
    };

    // 重置
    var handle_reset = () => {
      key_word.value = "";
      timerange.value = [];
      get_supplies_list();
    };
    watchEffect(() => {
      dialogVisible.value = props.isShow;
    });
    onMounted(() => {});
    watch(() => {
      return dialogVisible.value;
    }, () => {
      wl_fy.value.page = 1;
      if (!dialogVisible.value) {
        emit("closeDialog");
      } else {
        if (props.supplies.details) {
          if (props.supplies.type == -1) {
            quotation_checked_ids.value = Array.from(props.supplies.details, _ref2 => {
              var {
                code
              } = _ref2;
              return code;
            });
          } else {
            quotation_checked_ids.value = Array.from(props.supplies.details, _ref3 => {
              var {
                id
              } = _ref3;
              return id;
            });
          }
        }
        wl_fy.value.page = 1;
        get_supplies_list();
        console.log();
        // supplies_checked_list.value = props.supplies.details;
      }
    });
    watch(() => {
      return props.supplies;
    }, () => {
      if (props.supplies.details) {
        if (props.supplies.type == -1) {
          quotation_checked_ids.value = Array.from(props.supplies.details, _ref4 => {
            var {
              code
            } = _ref4;
            return code;
          });
        } else {
          quotation_checked_ids.value = Array.from(props.supplies.details, _ref5 => {
            var {
              id
            } = _ref5;
            return id;
          });
        }
      }
    });
    return (_ctx, _cache) => {
      var _component_el_input = _resolveComponent("el-input");
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_table_column = _resolveComponent("el-table-column");
      var _component_el_table = _resolveComponent("el-table");
      var _component_el_pagination = _resolveComponent("el-pagination");
      var _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        "destroy-on-close": true,
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => dialogVisible.value = $event),
        title: '请选择' + __props.supplies.tagName + (__props.supplies.type == -2 ? '' : '产品明细'),
        style: {
          "width": "80%"
        },
        onClose: handle_close
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_21, [_createVNode(_component_el_button, {
          onClick: handle_close
        }, {
          default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handle_checked,
          disabled: isConfirmDisabled.value
        }, {
          default: _withCtx(() => _cache[20] || (_cache[20] = [_createTextVNode(" 确定 ")])),
          _: 1
        }, 8, ["disabled"])])]),
        default: _withCtx(() => [__props.supplies.type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
          modelValue: key_word.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => key_word.value = $event),
          placeholder: "产品名称、货号、规格"
        }, null, 8, ["modelValue"]), _cache[10] || (_cache[10] = _createTextVNode("   ")), _createVNode(_component_el_button, {
          type: "primary",
          onClick: search
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("查询")])),
          _: 1
        })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_table, {
          data: supplies_list.value,
          style: {
            "height": "100%"
          },
          "row-key": row => row.id,
          ref_key: "multipleTableRef1",
          ref: multipleTableRef1,
          border: "",
          "cell-style": {
            padding: '3px 0'
          },
          onSelect: handleSelectionChange,
          onSelectAll: handleSelectionChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            "reserve-selection": true
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "产品名称",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "product_number",
            label: "货号",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "unit",
            label: "规格",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.min_qty) + _toDisplayString(scope.row.unit), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "inventory",
            label: "库存",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "manager_value",
            label: "产品经理"
          })]),
          _: 1
        }, 8, ["data", "row-key"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_pagination, {
          "current-page": wl_fy.value.page,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = $event => wl_fy.value.page = $event),
          background: "",
          layout: "total,prev, pager, next",
          "page-size": wl_fy.value.limit,
          total: wl_fy.value.total,
          onCurrentChange: handleCurrentChange,
          small: ""
        }, null, 8, ["current-page", "page-size", "total"])])])])) : _createCommentVNode("", true), __props.supplies.type == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_input, {
          modelValue: key_word.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => key_word.value = $event),
          placeholder: "请输入型号/物料名称查询",
          onKeyup: search
        }, null, 8, ["modelValue"]), _cache[12] || (_cache[12] = _createTextVNode("   ")), _createVNode(_component_el_button, {
          type: "primary",
          onClick: search
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("查询")])),
          _: 1
        })]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_table, {
          data: supplies_list.value,
          style: {
            "height": "100%"
          },
          "row-key": row => row.id,
          ref_key: "multipleTableRef2",
          ref: multipleTableRef2,
          border: "",
          "cell-style": {
            padding: '3px 0'
          },
          onSelectionChange: handleSelectionChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            "reserve-selection": true,
            type: "selection"
          }), _createVNode(_component_el_table_column, {
            prop: "model",
            label: "型号",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "list_price",
            label: "目录价",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "物料名称",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "code",
            label: "物料编码",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.code), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "carton_size",
            label: "包装规格",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: props.title == '报价' ? 'insourcing_number' : 'basic_unit',
            label: "单位"
          }, null, 8, ["prop"])]),
          _: 1
        }, 8, ["data", "row-key"])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_pagination, {
          "current-page": wl_fy.value.page,
          "onUpdate:currentPage": _cache[3] || (_cache[3] = $event => wl_fy.value.page = $event),
          background: "",
          layout: "total,prev, pager, next",
          "page-size": wl_fy.value.limit,
          total: wl_fy.value.total,
          onCurrentChange: handleCurrentChange,
          small: ""
        }, null, 8, ["current-page", "page-size", "total"])])])])) : _createCommentVNode("", true), __props.supplies.type == -1 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_input, {
          modelValue: key_word.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => key_word.value = $event),
          placeholder: "规格型号、物料编码、名称"
        }, null, 8, ["modelValue"]), _cache[15] || (_cache[15] = _createTextVNode("   ")), _createVNode(_component_el_button, {
          type: "primary",
          onClick: search
        }, {
          default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("查询")])),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: handle_reset
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("重置")])),
          _: 1
        })]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_el_table, {
          data: supplies_list.value,
          style: {
            "height": "100%"
          },
          "row-key": row => row.code,
          ref_key: "multipleTableRef3",
          ref: multipleTableRef3,
          border: "",
          "cell-style": {
            padding: '3px 0'
          },
          onSelect: handleSelectionChange,
          onSelectAll: handleSelectionChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            "reserve-selection": true
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "物料名称",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "code",
            label: "物料编码",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "unit",
            label: "规格型号",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.model), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "sale_unit",
            label: "单位",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "list_price",
            label: "目录价",
            "show-overflow-tooltip": ""
          })]),
          _: 1
        }, 8, ["data", "row-key"])])]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_pagination, {
          "current-page": wl_fy.value.page,
          "onUpdate:currentPage": _cache[5] || (_cache[5] = $event => wl_fy.value.page = $event),
          background: "",
          layout: "total,prev, pager, next",
          "page-size": wl_fy.value.limit,
          total: wl_fy.value.total,
          onCurrentChange: handleCurrentChange,
          small: ""
        }, null, 8, ["current-page", "page-size", "total"])])])) : _createCommentVNode("", true), __props.supplies.type == -2 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_input, {
          style: {
            "width": "300px"
          },
          modelValue: key_word.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => key_word.value = $event),
          placeholder: "客户名称、货号"
        }, null, 8, ["modelValue"]), _cache[18] || (_cache[18] = _createTextVNode("   ")), _createVNode(_component_el_button, {
          type: "primary",
          onClick: search
        }, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("查询")])),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: handle_reset
        }, {
          default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("重置")])),
          _: 1
        })]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createVNode(_component_el_table, {
          data: supplies_list.value,
          style: {
            "height": "100%"
          },
          "row-key": row => row.id,
          ref_key: "multipleTableRef2",
          ref: multipleTableRef2,
          border: "",
          "cell-style": {
            padding: '3px 0'
          },
          onSelect: handleSelectionChange,
          onSelectAll: handleSelectionChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            "reserve-selection": true
          }), _createVNode(_component_el_table_column, {
            prop: "sn",
            label: "报价单号",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            label: "客户名称",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx(scope => {
              var _scope$row$client_inf;
              return [_createTextVNode(_toDisplayString((_scope$row$client_inf = scope.row.client_info) === null || _scope$row$client_inf === void 0 ? void 0 : _scope$row$client_inf.company), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "",
            label: "创建时间",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.created_at), 1)]),
            _: 1
          })]),
          _: 1
        }, 8, ["data", "row-key"])])]), _createElementVNode("div", _hoisted_20, [_createVNode(_component_el_pagination, {
          "current-page": wl_fy.value.page,
          "onUpdate:currentPage": _cache[7] || (_cache[7] = $event => wl_fy.value.page = $event),
          background: "",
          layout: "total,prev, pager, next",
          "page-size": wl_fy.value.limit,
          total: wl_fy.value.total,
          onCurrentChange: handleCurrentChange,
          small: ""
        }, null, 8, ["current-page", "page-size", "total"])])])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};